export default __webpack_public_path__ + "static/media/avatar_152.afd477eb.png";